import { render, staticRenderFns } from "./menuList.vue?vue&type=template&id=403558fa&"
import script from "./menuList.vue?vue&type=script&lang=js&"
export * from "./menuList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports